enum reportStatuses {
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETE = 'COMPLETE',
  ERRORED = 'ERRORED'
}

export default reportStatuses